import React, { useState } from 'react';
import { Link } from 'react-router-dom';
import api from '../../services/api';
import { getAiVisCssVars } from './aivisTheme';
import './ai-vis.css';

export default function AiVisForgotPasswordPage() {
  const [email, setEmail] = useState('');
  const [submitted, setSubmitted] = useState(false);
  const [error, setError] = useState('');
  const [busy, setBusy] = useState(false);

  async function onSubmit(e) {
    e.preventDefault();
    setError('');
    setBusy(true);
    try {
      await api.post('/aivis/auth/forgot-password/', { email: email.trim().toLowerCase() });
      setSubmitted(true);
    } catch (err) {
      const d = err.response?.data;
      setError(d?.detail || 'Something went wrong. Please try again.');
    } finally {
      setBusy(false);
    }
  }

  return (
    <div className="aivis-auth-page" style={getAiVisCssVars()}>
      <div className="aivis-auth-card">
        <h1>AI-Vis</h1>
        <p>Reset your password</p>

        {submitted ? (
          <>
            <div className="aivis-positive" style={{ marginBottom: 16 }}>
              If that email is registered you will receive a reset link shortly. Check your inbox.
            </div>
            <div className="aivis-auth-link">
              <Link to="/ai-vis/login">Back to sign in</Link>
            </div>
          </>
        ) : (
          <>
            {error && <div className="aivis-auth-error">{error}</div>}
            <form onSubmit={onSubmit}>
              <div className="aivis-field">
                <label htmlFor="aivis-forgot-email">Email address</label>
                <input
                  id="aivis-forgot-email"
                  type="email"
                  autoComplete="username"
                  value={email}
                  onChange={(e) => setEmail(e.target.value)}
                  placeholder="you@company.com"
                  required
                />
              </div>
              <button type="submit" className="aivis-btn-primary" disabled={busy}>
                {busy ? 'Sending…' : 'Send reset link'}
              </button>
            </form>
            <div className="aivis-auth-link">
              <Link to="/ai-vis/login">Back to sign in</Link>
            </div>
          </>
        )}
      </div>
    </div>
  );
}
